import { Project } from '../../models/Project';
import { actionCreator } from '../common';
import { projectActionTypes } from '../types/project';

export const projectActionCreator = {
  changeProject: actionCreator<Project>(projectActionTypes.CHANGE_PROJECT_DATA),
};
